/* ─── STITCH CULTURE — THEME.JS ─── */

document.addEventListener('DOMContentLoaded', function () {

  /* ── ROTATING ANNOUNCEMENT BAR ── */
  var bar = document.querySelector('.announcement-bar[data-rotate="true"]');
  if (bar) {
    var msgs = bar.querySelectorAll('.announcement-msg');
    if (msgs.length > 1) {
      var idx = 0;
      var speed = parseInt(bar.dataset.speed, 10) || 4000;
      setInterval(function () {
        msgs[idx].classList.remove('is-active');
        idx = (idx + 1) % msgs.length;
        msgs[idx].classList.add('is-active');
      }, speed);
    }
  }

  /* ── MOBILE MENU ── */
  var hamburger = document.getElementById('HamburgerBtn');
  var mobileMenu = document.getElementById('MobileMenu');
  var overlay = document.getElementById('MobileOverlay');
  var closeBtn = document.getElementById('MobileMenuClose');

  function openMenu() {
    mobileMenu.classList.add('open');
    overlay.classList.add('open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileMenu.classList.remove('open');
    overlay.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  /* ── SEARCH ── */
  var searchToggle = document.getElementById('SearchToggle');
  var searchBar = document.getElementById('SearchBar');
  var searchClose = document.getElementById('SearchClose');

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('open');
      var isOpen = searchBar.classList.contains('open');
      searchBar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if (isOpen) searchBar.querySelector('.search-input').focus();
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', function () {
      searchBar.classList.remove('open');
      searchBar.setAttribute('aria-hidden', 'true');
    });
  }

  /* ── PRODUCT VARIANTS ── */
  var variantData = document.getElementById('ProductVariants');
  if (variantData) {
    try {
      window.productVariants = JSON.parse(variantData.textContent);
    } catch (e) {
      window.productVariants = [];
    }
    window.selectedOptions = {};
    window.currentImageIndex = 0;
  }

  function moneyFormat(paise) {
    // Match Shopify's "Rs. 2,790.00" format so JS-updated prices are
    // consistent with the on-load Liquid {{ | money }} output.
    var amount = (paise / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return 'Rs. ' + amount;
  }

  function updatePriceDisplay(variant) {
    var priceEl = document.getElementById('ProductPrice');
    if (!priceEl) return;
    var html = '<span class="price-main">' + moneyFormat(variant.price) + '</span>';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += '<span class="price-old">' + moneyFormat(variant.compare_at_price) + '</span>';
      var pctOff = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      html += '<span class="price-save">' + pctOff + '% OFF</span>';
    }
    priceEl.innerHTML = html;

    var atcBtn = document.getElementById('AddToCartBtn');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  window.selectOption = function (optionName, value, el) {
    var container = el.closest('.colour-row, .size-row');
    if (container) {
      container.querySelectorAll('.colour-chip, .size-btn').forEach(function (b) { b.classList.remove('active'); });
    }
    el.classList.add('active');

    var labelId = (optionName === 'Colour' || optionName === 'Color') ? 'SelectedColour' : 'SelectedSize';
    var label = document.getElementById(labelId);
    if (label) label.textContent = '\u2014 ' + value;

    window.selectedOptions[optionName] = value;

    if (window.productVariants && window.productVariants.length) {
      var match = window.productVariants.find(function (variant) {
        return Object.keys(window.selectedOptions).every(function (key) {
          return variant.options.indexOf(window.selectedOptions[key]) !== -1;
        });
      });
      if (match) {
        document.getElementById('VariantId').value = match.id;
        updatePriceDisplay(match);
        history.replaceState(null, '', '?variant=' + match.id);
      }
    }
  };

  // Delegated listeners for colour + size option buttons (quote-proof)
  document.querySelectorAll('.colour-chip[data-value], .size-btn[data-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      window.selectOption(btn.dataset.option, btn.dataset.value, btn);
    });
  });

  window.changeQty = function (delta) {
    var input = document.getElementById('QtyInput');
    var display = document.getElementById('QtyVal');
    if (!input) return;
    var val = Math.max(1, Math.min(10, parseInt(input.value, 10) + delta));
    input.value = val;
    if (display) display.textContent = val;
  };

  /* ── GALLERY ── */
  var thumbs = document.querySelectorAll('.gallery-thumbs .thumb');
  var mainImg = document.getElementById('MainProductImage');

  window.setMainImage = function (src, thumbEl) {
    if (mainImg) mainImg.src = src;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    if (thumbEl) thumbEl.classList.add('active');
    window.currentImageIndex = Array.prototype.indexOf.call(thumbs, thumbEl);
  };

  window.changeImage = function (dir) {
    if (!thumbs.length) return;
    window.currentImageIndex = (window.currentImageIndex + dir + thumbs.length) % thumbs.length;
    thumbs[window.currentImageIndex].click();
  };

  /* ── ADD TO CART ── */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('AddToCartBtn');
      var originalText = btn.textContent;
      btn.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: document.getElementById('VariantId').value,
          quantity: parseInt(document.getElementById('QtyInput').value, 10)
        })
      })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
        } else {
          var cartBtn = document.querySelector('.cart-icon-btn');
          if (cartBtn && cart.item_count > 0) {
            var badge = document.createElement('span');
            badge.className = 'cart-count';
            badge.textContent = cart.item_count;
            cartBtn.appendChild(badge);
          }
        }
        btn.textContent = 'Added \u2713';
        setTimeout(function () { btn.textContent = originalText; }, 1800);
      })
      .catch(function () { btn.textContent = originalText; });
    });
  }

   window.buyNow = function () {
    var btn = document.querySelector('.buy-now-btn');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Please wait\u2026'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: document.getElementById('VariantId').value,
        quantity: parseInt(document.getElementById('QtyInput').value, 10) || 1
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('add failed');
      // Go to checkout through a real link click, the same way the cart
      // page button works, so Razorpay Magic Checkout can pick it up.
      var a = document.createElement('a');
      a.href = '/checkout';
      a.className = 'checkout-btn';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
      window.location.href = '/cart';
    });
  };

  /* ── ACCORDION ── */
  window.toggleAcc = function (header) {
    var body = header.nextElementSibling;
    var isOpen = header.classList.contains('open');
    var accordion = header.closest('.accordion');
    accordion.querySelectorAll('.acc-header').forEach(function (h) {
      h.classList.remove('open');
      h.setAttribute('aria-expanded', 'false');
    });
    accordion.querySelectorAll('.acc-body').forEach(function (b) { b.classList.remove('open'); });
    if (!isOpen) {
      header.classList.add('open');
      header.setAttribute('aria-expanded', 'true');
      body.classList.add('open');
    }
  };


  /* ── SIZE CHART UNIT TOGGLE (default inches) ── */
  window.setSizeUnit = function (unit, btn) {
    var modal = document.getElementById('SizeChartModal');
    if (!modal) return;
    modal.querySelectorAll('.unit-btn').forEach(function (b) { b.classList.remove('is-active'); });
    if (btn) btn.classList.add('is-active');
    modal.querySelectorAll('.sc-val').forEach(function (cell) {
      var v = unit === 'cm' ? cell.getAttribute('data-cm') : cell.getAttribute('data-in');
      cell.textContent = unit === 'cm' ? (v + ' cm') : (v + '"');
    });
  };

  /* ── SIZE CHART MODAL ── */
  window.openSizeChart = function () {
    var modal = document.getElementById('SizeChartModal');
    if (!modal) return;
    var activeChart = modal.dataset.activeChart;
    modal.querySelectorAll('.size-chart-table-wrap').forEach(function (wrap) {
      if (wrap.dataset.chart === activeChart) {
        wrap.classList.add('active');
      } else {
        wrap.classList.remove('active');
      }
    });
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  window.closeSizeChart = function () {
    var modal = document.getElementById('SizeChartModal');
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = document.getElementById('SizeChartModal');
      if (modal && modal.classList.contains('open')) window.closeSizeChart();
    }
  });

  /* ── CART UPDATE ── */
  window.updateCartItem = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (res) { return res.json(); })
    .then(function () { window.location.reload(); })
    .catch(function (err) { console.error('Cart update error:', err); });
  };

});
